module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/icon_case04-26fcd14f3b756041dd764bb03f0d45c5.svg";